// @flow

export const DEFAULT_LIST_ITEM_HEIGHT = 40
